import {isMediaFileTypeAsset} from '@netx/core-asset-next/utils/isMediaFileTypeAsset';

export const assetHasAudio = (
	fileFormatFamily?: string[],
	viewNames?: string[],
) =>
	isMediaFileTypeAsset(fileFormatFamily) &&
	viewNames?.includes('previewMp3') === true;

export default assetHasAudio;
